var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWeb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.66663C12.0844 3.94859 13.269 6.90999 13.3334 9.99996C13.269 13.0899 12.0844 16.0513 10 18.3333M10 1.66663C7.91562 3.94859 6.73106 6.90999 6.66669 9.99996C6.73106 13.0899 7.91562 16.0513 10 18.3333M10 1.66663C5.39765 1.66663 1.66669 5.39759 1.66669 9.99996C1.66669 14.6023 5.39765 18.3333 10 18.3333M10 1.66663C14.6024 1.66663 18.3334 5.39759 18.3334 9.99996C18.3334 14.6023 14.6024 18.3333 10 18.3333M2.08337 7.49996H17.9167M2.08335 12.5H17.9167",
    stroke: "#4BC1C5",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeb);
export default __webpack_public_path__ + "static/media/web.14c6fe90bf617ba2ea581ddef446b6f5.svg";
export { ForwardRef as ReactComponent };